<div class="action-list" *ngIf="actionList">
  <ngb-accordion #acc="ngbAccordion" activeIds="panel-0">
    <ng-container *ngFor="let action of controls; let i = index; trackBy: trackByIndex">
      <ngb-panel id="panel-{{ i }}" [cardClass]="'card-fit mb-1'">
        <ng-template ngbPanelTitle let-opened="opened">
          <div class="flex justify-content-between align-items-center gap-2">
            <span> Ação {{ i + 1 }} </span>
            <div class="flex align-items-center gap-2">
              <span class="arrow-icon-wrapper">
                <i
                  [class]="
                    acc.isExpanded('panel-' + i) ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
                  "
                ></i>
              </span>
              <button
                *ngIf="controls.length > 1 && !readOnly"
                type="button"
                class="btn btn-sm btn-flat-danger btn-iconn w-auto btn-trash"
                (click)="onRemoveClicked(i, $event)"
              >
                <i data-feather="trash"></i>
              </button>
            </div>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div [formGroup]="action">
            <div class="form-group">
              <label class="form-control-label form-label" for="type-{{ i }}">Tipo</label>
              <ng-select
                class="ng-select-custom auto-grow-options"
                [items]="actionTypeOptions"
                appendTo="body"
                bindLabel="label"
                bindValue="value"
                placeholder="Tipo"
                formControlName="type"
              ></ng-select>
              <app-error-msg label="Tipo" [control]="action.get('type')"></app-error-msg>
            </div>

            <div class="form-group">
              <label class="form-control-label form-label" for="what-{{ i }}">O que</label>
              <input
                id="what-{{ i }}"
                type="text"
                class="form-control"
                placeholder="O que"
                formControlName="what"
              />
              <app-error-msg label="O que" [control]="action.get('what')"></app-error-msg>
            </div>

            <div class="form-group">
              <label class="form-control-label form-label" for="responsible-{{ i }}"
                >Responsável</label
              >
              <ng-select
                title="Selecione os participantes internos"
                class="ng-select-participants ng-select-custom"
                [items]="employees$ | async"
                appendTo="body"
                [loading]="employeesLoading"
                bindLabel="name"
                [multiple]="false"
                placeholder="Busque pelo nome do funcionário"
                loadingText="Carregando"
                [typeahead]="employeeSearchInput$"
                notFoundText="Nenhum item encontrado"
                [minTermLength]="3"
                [closeOnSelect]="true"
                formControlName="responsible"
                typeToSearchText="Busque pelo nome do funcionário"
              >
              </ng-select>
              <app-error-msg
                label="Responsável"
                [control]="action.get('responsible')"
              ></app-error-msg>
            </div>

            <div class="form-group">
              <label class="form-control-label form-label" for="description-{{ i }}"
                >Descrição</label
              >
              <textarea
                id="description-{{ i }}"
                class="form-control"
                placeholder="Descrição"
                formControlName="description"
                rows="4"
              ></textarea>
              <app-error-msg
                label="Descrição"
                [control]="action.get('description')"
              ></app-error-msg>
            </div>

            <div class="form-group">
              <label class="form-control-label form-label" for="forecastDate-{{ i }}"
                >Previsão</label
              >
              <input
                id="forecastDate-{{ i }}"
                type="date"
                class="form-control"
                placeholder="Previsão"
                formControlName="forecastDate"
              />
              <app-error-msg
                label="Previsão"
                [control]="action.get('forecastDate')"
              ></app-error-msg>
            </div>

            <div class="form-group" [class.mb-0]="!hasResolutionData(i)">
              <label class="form-control-label form-label" for="status-{{ i }}">Status</label>
              <ng-select
                class="ng-select-custom auto-grow-options"
                [items]="actionStatusOptions"
                appendTo="body"
                bindLabel="label"
                bindValue="value"
                placeholder="Status"
                formControlName="status"
              ></ng-select>
              <app-error-msg label="Status" [control]="action.get('status')"></app-error-msg>
            </div>

            <ng-container *ngIf="hasResolutionData(i)">
              <div class="col-md-12 col-12">
                <div class="divider divider-primary">
                  <div class="divider-text">Resolução</div>
                </div>
              </div>
              <div class="form-group">
                <label class="form-control-label form-label" for="resolutionDescription-{{ i }}">
                  Descrição da resolução <span class="text-danger" *ngIf="!readOnly">*</span>
                </label>
                <textarea
                  id="resolutionDescription-{{ i }}"
                  class="form-control"
                  placeholder="Descrição da resolução"
                  rows="3"
                  formControlName="resolutionDescription"
                  [readonly]="readOnly"
                  [disabled]="readOnly"
                ></textarea>
                <div
                  *ngIf="!readOnly && action.hasError('resolutionDescriptionRequired')"
                  class="invalid-feedback d-block"
                >
                  Descrição da resolução é obrigatória quando o status é Em andamento ou Concluído.
                </div>
              </div>
              <div class="form-group mb-0">
                <label class="form-control-label form-label">Arquivo <span class="text-muted">(opcional)</span></label>
                <app-dropzone-files
                  [readonly]="readOnly"
                  [multiple]="false"
                  [fileContent]="getResolutionFileContent(i)"
                  [allowedFileTypes]="['application/pdf', 'image/png', 'image/jpeg', 'image/jpg']"
                  (onChangeFiles)="onResolutionFileChange($event, i)"
                  (onGetFile)="onGetActionFile(i)"
                ></app-dropzone-files>
              </div>
            </ng-container>
          </div>
        </ng-template>
      </ngb-panel>
    </ng-container>
  </ngb-accordion>

  <ng-container *ngIf="!readOnly">
    <div class="flex mt-1">
      <button
        type="button"
        class="btn btn-sm btn-flat-secondary w-auto mx-auto mt-1"
        (click)="onAddClicked()"
      >
        <i data-feather="plus"></i> Adicionar
      </button>
    </div>
  </ng-container>
</div>

